import { render } from "./MoodyPage.vue?vue&type=template&id=4633466e&scoped=true"
import script from "./MoodyPage.vue?vue&type=script&lang=js"
export * from "./MoodyPage.vue?vue&type=script&lang=js"

import "./MoodyPage.vue?vue&type=style&index=0&id=4633466e&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4633466e"]])

export default __exports__